import { Button } from "@/components";
import { useDesignMaxTheme } from "@/packages";
import { useBookingRecoilValue, usePensionNameValue } from "@/shared/client";
import { type AboutDmaxInfoResponse } from "@/shared/server";
import { FONT } from "@/styles";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import DOMPurify from "dompurify";

export const AboutSection = ({ about }: { about: AboutDmaxInfoResponse }) => {
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile, isLaptop } = MEDIAS();
    const pensionName = usePensionNameValue();
    const bookingURL = useBookingRecoilValue();

    const onLink = (url: string) => {
        if (bookingURL.includes("http")) {
            window.open(url, "_blank");
        }
        if (!bookingURL.includes("http")) {
            window.open(`https://${url}`, "_blank");
        }
    };

    const { imgList, sector } = { ...about };

    return (
        <Center w="100%">
            <Center position="relative" as="section">
                <Box display="inline-flex" p={isMobile ? "0 20px" : "0 48px"} flexDir={isMobile ? "column" : "row"}>
                    <Center
                        maxW={isLaptop ? "592px" : "688px"}
                        w="100%"
                        // eslint-disable-next-line no-nested-ternary
                        p={isMobile ? "24px 0" : "0 80px 48px 0"}
                        // eslint-disable-next-line no-nested-ternary
                        pr={isMobile ? "0" : isLaptop ? "64px" : "80px"}
                        alignItems="flex-start"
                        flexDir="column"
                        gap="8px"
                        sx={{
                            "& p": { color: "#333" },
                        }}
                    >
                        <Text
                            // eslint-disable-next-line no-nested-ternary
                            {...FONT("cormorant", isMobile ? 16 : isLaptop ? 24 : 36, 300, 1.2)}
                        >
                            {pensionName.eng}
                        </Text>
                        <Text
                            // eslint-disable-next-line no-nested-ternary
                            {...FONT("cormorant", isMobile ? 32 : isLaptop ? 48 : 56, 700, 1.2)}
                        >
                            ABOUT
                        </Text>
                        <Box pl={isMobile ? "24px" : "56px"}>
                            <Text
                                // eslint-disable-next-line no-nested-ternary
                                {...FONT("pretendard", isMobile ? 12 : isLaptop ? 16 : 18, 300, 1.4)}
                                color="#6b6b6b !important"
                            >
                                {sector.firstLine}
                            </Text>
                            <Text
                                // eslint-disable-next-line no-nested-ternary
                                {...FONT("pretendard", isMobile ? 12 : isLaptop ? 16 : 18, 300, 1.4)}
                                color="#6b6b6b !important"
                            >
                                {sector.secondLine}
                            </Text>
                        </Box>
                    </Center>
                    <Flex flex="1" gap={isLaptop ? "64px" : "80px"} alignItems={isLaptop ? "center" : "normal"}>
                        {!isMobile && <Box mt={isLaptop ? "0" : "104PX"} w="2px" h="400px" bg="#6b6b6b" />}
                        <Flex flex="1" flexDir="column" gap="80px">
                            <Flex flexDir="column" gap={isMobile ? "24px" : "48px"}>
                                <Box position="relative" w="100%">
                                    <Box
                                        position="relative"
                                        zIndex="3"
                                        w="100%"
                                        // eslint-disable-next-line no-nested-ternary
                                        h={isMobile ? "224px" : isLaptop ? "360px" : "592px"}
                                        bg={
                                            imgList[0] ? `url(${imgList[0].img_URL})no-repeat center/cover` : "gray.100"
                                        }
                                        transform="translateZ(0)"
                                    />
                                    {!isLaptop && (
                                        <Box
                                            position="absolute"
                                            zIndex="0"
                                            display={!isLaptop ? "block" : "none"}
                                            top="50%"
                                            right="-132px"
                                            w="212px"
                                            h="400px"
                                            transform="translateY(-50%)"
                                            bg="#3b6c8d"
                                        />
                                    )}
                                </Box>
                                <Text
                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(sector.thirdLine) }}
                                    // eslint-disable-next-line no-nested-ternary
                                    {...FONT("pretendard", isMobile ? 12 : isLaptop ? 16 : 18, 300, 1.4)}
                                />
                            </Flex>
                            <Box>
                                <Button
                                    w={isMobile ? "100%" : "auto !important"}
                                    sizeType="large"
                                    roundType="none"
                                    color="#333"
                                    {...FONT("cormorant", 24, 300, 1.2)}
                                    onClick={() => onLink(bookingURL)}
                                >
                                    Reservation
                                </Button>
                            </Box>
                        </Flex>
                    </Flex>
                </Box>
            </Center>
        </Center>
    );
};
